const GranularApp = (($) => {
    const fire = () => {
        $(document).foundation();
        Menu.init();
        IntegratedModelSlider.init();
        SyncSlider.init();
        StickyMenu.init();
        CookieNotification.init();

        const video = document.getElementById('hero-video__video');
        if (video) {
            video.play();
        }

        var UAString = navigator.userAgent;
        if (UAString.indexOf("Trident") !== -1 && UAString.indexOf("rv:11") !== -1){
            $("html").addClass('ie11');
        }


        if (!$("html").hasClass('object-fit')) {
           $('.object_fit').each((function () {
               var $container = $(this),
               imgUrl = $container.find('img').prop('src');
               if (imgUrl) {
                   $container
                       .css('backgroundImage', 'url(' + imgUrl + ')')
                       .addClass('compat');
               }
           }));
       }


       $(".js_download_list_item").click((function(){
        var target = $(this).data('target');
        $(target).addClass('active');
       }));

       $(".fc_download_list__modal").click((function(e){
           if(e.target != this) return;
           $(this).removeClass('active');
       }));

        $('#statements').owlCarousel({
            loop: true,
            items: 1,
            dots: true,
            autoplay: true,
            autoplayTimeout: 7000,
            smartSpeed: 700
        });

        $(".js_fc_team_members").owlCarousel({
            dots: true,
            loop: false,
            responsive: {
                0: {
                    items: 1,
                    slideBy: 1,
                },
                370: {
                    items: 2,
                    slideBy: 2,
                },
                768: {
                    items: 3,
                    slideBy: 3,
                }
            }
        });

        $('#rotating-captions').owlCarousel({
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
            loop: true,
            items: 1,
            dots: false,
            autoplay: true,
            smartSpeed: 2000,
        });

        $(".js_team_member_button").click((function(){
            var id = $(this).data('id');
            var overlay = $(this).data('overlay');
            var carousel = $(this).data('carousel');

            $("body").addClass('no_scroll');
            $(carousel).trigger("to.owl.carousel", [id]);
            $(overlay).addClass('active');
        }));

        $(".js_team_members_carousel").owlCarousel({
            loop: true,
            items: 1,
            nav: true,
            navText: ['',''],
            dots: false,
        });

        $(".js_team_members_carousel_close").click((function(){
            var target = $(this).data('target');
            team_members_carousel_close(target);
        }));

        function team_members_carousel_close(target){
            $("body").removeClass('no_scroll');
            $(target).removeClass('active');
        }


        $(".js_fc_fade_carousel_images_carousel").owlCarousel({
            loop: true,
            items: 1,
            nav: false,
            dots: false,
            mouseDrag:false,
            touchDrag: false,
        }).addClass('owl-carousel');

        $(".js_fc_fade_carousel_contents_carousel").owlCarousel({
            loop: true,
            items: 1,
            nav: true,
            navText: ['',''],
            dots: false,
            mouseDrag:false,
            touchDrag: false,
        }).addClass('owl-carousel').on('changed.owl.carousel',(function(event){

            var count = event.item.count-1;
            var current = Math.round(event.item.index - (event.item.count/2) - .5);

            if(current < 0) {
              current = count;
            }
            if(current > count) {
              current = 0;
            }

            $($(this).data('partner')).trigger('to.owl.carousel',[current])
        }))

        $('#work-carousel').owlCarousel({
            loop: false,
            items: 3,
            dots: true,
            autoplay: false,
            smartSpeed: 450,
            margin: 15,
            responsive: {
                0: {
                    items: 1,
                    dots: false,
                    nav: true
                },
                700: {
                    items: 2
                },
                1030: {
                    items: 3
                }
            }
        });

        const teamMembers = $('#team-members-carousel').owlCarousel({
            loop: false,
            items: 3,
            dots: true,
            autoplay: false,
            smartSpeed: 450,
            margin: 15,
            responsive: {
                0: {
                    items: 1,
                    dots: false,
                    nav: true
                },
                700: {
                    items: 2
                },
                1030: {
                    items: 3
                }
            }
        });

        $('.js_newsletters').owlCarousel({
            loop: false,
            items: 3,
            dots: true,
            autoplay: false,
            margin: 30,
            responsive: {
                0: {
                    items: 1,
                },
                700: {
                    items: 2
                },
                1030: {
                    items: 3
                }
            }
        });

        var $climate_numbers = $(".js_climate_increment");
        if($climate_numbers.length>0){

            $climate_numbers.each((function(){

                var $counter = $(this);
                var number = $counter.data('number');
                var increment = $counter.data('increment');
                var interval = 1000 / increment;

                setInterval((function(){
                    $counter.data('number', $counter.data('number') + 1);
                    $counter.text((function(){
                        return parseInt( $counter.data('number') ).toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
                    }));
                }),interval);
            }));
        }


        $(".js_team_members_country_select select").change((function(){
            var office_id = $(this).val();

            update_office_dom(office_id);
            update_form_dom('office', office_id);

        }));

        $(".js_team_member_link").click((function(event){
            event.preventDefault();

            var team_member_id = $(this).data('id'),
                office_id = $(this).data('office-id'),
                href = $(this).attr('href'),
                target = $(this).data('target');

            team_members_carousel_close(target);

            update_office_dom(office_id);
            update_form_dom('team_member', team_member_id);
        }));

        function update_office_dom(office){
            $(".team_members__office").removeClass('active');
            $('.team_members__office[data-office="'+office+'"]').addClass('active');

            $(".team_members__country_select_list li").removeClass('active');
            $('.team_members__country_select_list li[data-office="'+office+'"]').addClass('active');
        }

        function update_form_dom(type, id){
            $(".input_name_team_member_type input").val(type);

            $(".input_name_team_member_id input").val(id);

        }

        $('.js_image_gallery').owlCarousel({
            loop: true,
            items: 1,
        });
        $(".js_testimonials").owlCarousel({
            loop: true,
            items: 1,
        });

        $(".js_overlay_and_carousel").owlCarousel({
            loop: true,
            items: 1,
            dots: true,
            autoplay:true,
            autoplayTimeout:4000,
        });

        $(".js_numbered_carousel").owlCarousel({
            loop: true,
            items: 1,
        });

        $(".opaque_section").hover((function(){
            $(this).attr("class", "opaque_section");
            $(this).siblings().attr("class", "opaque_section opaque");
        }),(function(){
            $(this).siblings().attr("class", "opaque_section");
        }));

        $(".accordion").on('up.zf.accordion', (function() {
            $(this).removeClass('accordion--opened');
        })).on('down.zf.accordion', (function() {
            $(this).addClass('accordion--opened');
        }));
        $(".js_video_play").click((function(){
            var $target = $($(this).data('target'));

            if($target.data('source')=='youtube'){

                $('iframe',$target).attr('src', (function(){
                    return $(this).attr('src') + '&autoplay=1';
                }));

            }else if($target.data('source')=='vimeo'){

                var iframe = $('iframe',$target)[0];
                var player = new Vimeo.Player(iframe);

                player.play();
            }

            $(this).closest('.fc_video__overlay').fadeOut();

        }));

    }; 
    return {
        fire: fire,
    };
})(jQuery);
document.addEventListener('DOMContentLoaded', () => GranularApp.fire());